import { render } from "./errorPage.vue?vue&type=template&id=bb613d76&scoped=true"
import script from "./errorPage.vue?vue&type=script&lang=js"
export * from "./errorPage.vue?vue&type=script&lang=js"

import "./errorPage.vue?vue&type=style&index=0&id=bb613d76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb613d76"]])

export default __exports__